import React from "react";
import "./notFound.css";

const NotFound = () => {
  return (
    <div className="NotFound text-center">
      <h3>Sorry, page not found!</h3>
    </div>
  );
};

export default NotFound;
